import React from "react";
import Modal from "react-bootstrap/Modal";
import { Tab, Tabs } from "react-bootstrap";
import cropr from "../../shared/utils/cropr";
import gettext from "../../shared/utils/gettext";
import { interpolate } from "../../shared/utils/legacy";
import Tractors from "./Tractors";
import APIClient from "../client";
import Jobs from "./Jobs";

class LinkClaasConnect extends React.Component {
  state = {
    showModal: false,
    account: null,
    showWarning: false,
  };

  constructor(props, context) {
    super(props, context);
    this.loadAccount();
  }

  componentDidMount() {
    cropr.updateClaasConnectState = () => {
      this.loadAccount();
    };
  }
  componentWillUnmount() {
    delete cropr.updateClaasConnectState;
  }

  loadAccount = () => {
    fetch("/apps/cloudfarm/get_tractors/CC/")
      .then((response) => {
        if (response.status === 401) {
          cropr.notify(
            "danger",
            interpolate(gettext("Your %s authorization seems to be no longer valid."), [
              "CLAAS Connect",
            ])
          );
        }
        if (response.ok) {
          response.json().then((account) => {
            this.setState({
              account: account,
              showWarning: false,
            });
          });
        } else {
          throw new Error(`get_tractors failed: ${response.status}`);
        }
      })
      .catch((error) => {
        this.setState({
          account: null,
        });
      });
  };

  authorizeAccount(scope) {
    const url = new URL("/apps/cloudfarm/claas_connect_authorization_url/", window.location.origin);
    url.searchParams.append("scope", scope);

    fetch(url)
      .then(function (response) {
        if (response.ok) {
          return response.json();
        } else {
          cropr.notify("danger", gettext("Your account could not be linked at this time."));
          throw new Error(`claas_connect_authorization_url failed: ${response.status}`);
        }
      })
      .then((json) => {
        window.open(json.claas_connect_authorization_url, "_blank");
        this.setState({ showWarning: true });
      })
      .catch((error) => console.error("Error:", error));
  }

  async removeAccount(scope = null) {
    try {
      await APIClient.remove(
        scope
          ? `/api/data/claas_connect/delete_credentials?scope=${scope}`
          : "/api/data/claas_connect/delete_credentials",
        null,
        cropr.cloudfarm_oauth_token
      ).then((response) => {
        cropr.notify("success", gettext("Deletion was successful."));
        this.loadAccount();
      });
    } catch {
      cropr.notify("danger", gettext("Your details could not be deleted at this time."));
    }
  }

  toggle(show) {
    this.setState({ showModal: show });
  }

  render() {
    return (
      <>
        <button type="button" className="dropdown-item" onClick={() => this.toggle(true)}>
          {gettext("Connect with CLAAS Connect")}
        </button>
        <Modal show={this.state.showModal} onHide={() => this.toggle(false)}>
          <Modal.Header closeButton>
            <Modal.Title style={{ width: "100%" }}>
              CLAAS Connect account
              <img
                className="float-right"
                src="/static/img/CLAAS.png"
                alt="CLAAS"
                style={{ height: "30px" }}
              />
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs defaultActiveKey={this.state.organization ? "tractors" : "account"}>
              <Tab eventKey="account" title={gettext("Account")}>
                {this.state.showWarning ? (
                  <div className="alert alert-info">
                    {gettext("Be sure to allow this page to open popup windows in your browser.")}
                  </div>
                ) : null}
                <div>
                  <h4 className="mt-2">{gettext("CLAAS Connect Online File Exchange")}</h4>
                  {this.state.account && this.state.account.scopes.includes("oft") ? (
                    <div>
                      <h6 className="mt-2">{gettext("Currently Connected")}</h6>

                      <div className="mt-4">
                        <button
                          type="button"
                          className="btn btn-warning mr-1"
                          onClick={() => this.removeAccount("oft")}
                        >
                          {gettext("Delete")}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="mt-4" style={{ paddingBottom: "0.5em" }}>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => this.authorizeAccount("oft")}
                        >
                          {gettext("Authorize")}
                        </button>
                      </div>
                    </div>
                  )}
                  <hr />
                  <h4 className="mt-2" style={{ paddingTop: "0.5em" }}>
                    {gettext("CLAAS Connect Online Point Data")}
                  </h4>
                  {this.state.account && this.state.account.scopes.includes("point-data") ? (
                    <div>
                      <h6 className="mt-2">{gettext("Currently Connected")}</h6>

                      <div className="mt-4">
                        <button
                          type="button"
                          className="btn btn-warning mr-1"
                          onClick={() => this.removeAccount("point-data")}
                        >
                          {gettext("Delete")}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className="mt-4" style={{ paddingBottom: "0.5em" }}>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => this.authorizeAccount("point-data")}
                        >
                          {gettext("Authorize")}
                        </button>
                      </div>
                    </div>
                  )}
                  {this.state.account ? (
                    <div>
                      <hr />
                      <h4 className="mt-2">{gettext("Connection Management")}</h4>
                      <div className="mt-4">
                        <button
                          type="button"
                          className="btn btn-warning mr-1"
                          onClick={() => this.removeAccount()}
                        >
                          {gettext("Delete All")}
                        </button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </Tab>
              <Tab eventKey="tractors" title={gettext("Tractors")} disabled={!this.state.account}>
                {this.state.account ? (
                  <Tractors
                    accountName={this.state.account.farm_name}
                    headers={[gettext("Name"), gettext("Vehicle type"), gettext("Scope")]}
                    tractors={this.state.account.tractors.map((t, i) => ({
                      display: [t.name, t.type ? t.type : "", t.scope],
                      serialNr: t.id,
                      receiveOnly: false,
                    }))}
                  />
                ) : null}
              </Tab>
              <Tab eventKey="tasks" title={gettext("Tasks")} disabled={!this.state.account}>
                {this.state.account ? <Jobs online_service="CC" /> : null}
              </Tab>
              <Tab eventKey="help" title={gettext("Help")}>
                <h5 className="mt-2">{gettext("What is a connection to CLAAS Connect?")}</h5>
                {interpolate(
                  gettext(
                    "If you possess equipment that is connected to %s, you can authorize Cloudfarm to exchange data with this platform. Please talk to your dealer for more information about this system."
                  ),
                  ["CLAAS Connect"]
                )}
                <h5 className="mt-2">{gettext("What can I do with it?")}</h5>
                {gettext(
                  "You can exchange task data directly between your vehicle and The Dacom platform/ Cloudfarm:"
                )}
                <ul>
                  <li>
                    {gettext(
                      'After connecting, your vehicle(s) will be present under the "Machines" menu. There, you can rename your vehicle, and attach a default recording template.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can send the base data for your farm to each vehicle, using the buttons in the "Tractors" tab in this dialog. The base data includes field boundaries and way lines.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'You can can create scheduled tasks for your work in the "Recording" menu. If you select a connected vehicle under "Machines", the relevant field boundary and way lines will be automatically transmitted to your vehicle.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'After completing a task on the vehicle, the "as applied" data is automatically loaded in Cloudfarm, where you can review the work done.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      'If you complete a task for a planning you created beforehand, this planning will automatically be marked "performed", and enriched with data from the task. Alternatively, if no planning was made, a concept recording will be created so you can conveniently convert this into a full recording.'
                    )}
                  </li>
                  <li>
                    {gettext(
                      ' If you use the vehicle to record field boundaries and way lines, you can easily import them into your Dacom farm by clicking "details" in the dataset card and go to the "geometry" tab. This way you can easily reuse this data for other vehicles, for instance by converting them into a different format with the "export machine data" functionality. '
                    )}
                  </li>
                </ul>
              </Tab>
            </Tabs>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default LinkClaasConnect;
